/** @format */

import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Spinner } from "@chakra-ui/react";
import PullToRefresh from "react-simple-pull-to-refresh";
import { LojaButton } from "../../components/LojaButton";
import { SearchInput } from "../../components/SearchInput";
import { useRecomendacao } from "../../context/useRecomendacao";
import { Lojas } from "./Lojas";
import { CardOfertaVertical } from "../../components/CardOferta/Vertical";
import { BoxList } from "../../components/BoxList";
import { formatRecomendacao, ordenaRecomendacoes } from "../../utils";
import CardCashbackVertical from "../../components/CardCashback/Vertical";
import { CardDescontoExclusivoVertical } from "../../components/CardDescontoExclusivo/Vertical";
import { EmptyState } from "../../components/EmptyState";
import { CardVerMais } from "../../components/CardVerMais";
import { usePersonalizacao } from "../../context/usePersonalizacao";
import { FiltrosList } from "../../components/FiltrosList";

export function Recomendacao() {
  const history = useHistory();
  const {
    selectedFiltros,
    addSelectedFilters,
    loja,
    recomendacao,
    filteredRecomendacao,
    requestRecomendacao,
    viewDescricao,
    descontoExclusivoLabel,
    destaquesLabel,
    ofertasLabel,
    cashbackLabel,
  } = useRecomendacao();

  const {
    personalizacao: { guiaofertas, card },
  } = usePersonalizacao();

  const [isModalLojaOpen, setIsModalLojaOpen] = useState(false);
  const { ofertas, descontoExclusivo, dinheiroDeVolta, destaques } =
    formatRecomendacao(
      selectedFiltros.length > 0 ? filteredRecomendacao : recomendacao,
      guiaofertas?.hasDestaques
    );

  useEffect(() => {
    let filterByFilterHome = selectedFiltros.filter((data) => {
      return data.isHome;
    });

    addSelectedFilters({ filtros: filterByFilterHome });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box maxWidth="900px" margin="0 auto" background="white" overflow="hidden">
      <Box
        background={guiaofertas.headerbackground}
        w="100%"
        maxWidth="900px"
        zIndex="sticky"
        paddingTop="1rem"
      >
        <Box paddingX="1rem">
          <SearchInput
            placeholder="Pesquisar oferta"
            _placeholder={[{ color: "#70747D" }]}
            onFocus={() => history.push("/pesquisa")}
          />
        </Box>
        <Box my="0.75rem">
          <FiltrosList />
        </Box>
        <Box px="1rem" py="0.75rem">
          <LojaButton
            loja={loja.nomeLojaSelecionada || "Selecione uma loja"}
            onClick={() => setIsModalLojaOpen(true)}
          />
          <Lojas
            isOpen={isModalLojaOpen}
            onRequestClose={() => setIsModalLojaOpen(false)}
          />
        </Box>
      </Box>
      <Box
        minH="100vh"
        background={guiaofertas.background !== undefined ? (guiaofertas.background ? guiaofertas.background : "#EDEEF2") : "#EDEEF2"}
        id="content-list-tab"
      >
        <Box
          height="100%"
          paddingTop="3rem"
          overflowY="hidden"
          overflowX="hidden"
        >
          <PullToRefresh
            onRefresh={requestRecomendacao}
            resistance={4}
            pullDownThreshold={20}
            maxPullDownDistance={70}
            pullingContent={
              <Box display="flex" alignItems="center" justifyContent="center">
                Puxe para atualizar
              </Box>
            }
            refreshingContent={
              <Box display="flex" alignItems="center" justifyContent="center">
                <Spinner color="#0D4E7E" />
              </Box>
            }
          >
            {destaques.length > 0 && (
              <Box w="100%" id="destaque-boxlist">
                <BoxList
                  isVisibleVermais={destaques.length >= 5}
                  title={destaquesLabel}
                  bgcolorTitle={card?.bgcortitle}
                  textcolorTitle={card?.cortextotitle}
                  onClick={() => history.push(`/vermais/destaques/4`)}
                >
                  {ordenaRecomendacoes(destaques, guiaofertas?.ordenacaoRecomendacao).slice(0, 5).map((data, index) => (
                    <Box height="100%" key={index}>
                      {data.idtiporecomendacao === "1" && (
                        <CardDescontoExclusivoVertical
                          key={data.idoferta}
                          props={data}
                          onClickCard={
                            !data.linkproduto
                              ? () => {
                                  history.push(`/descricao/1/${data.idoferta}`);
                                  viewDescricao(data);
                                }
                              : () => {
                                  window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                                  viewDescricao(data);
                                }
                          }
                        />
                      )}
                      {data.idtiporecomendacao === "2" && (
                        <CardOfertaVertical
                          key={data.idoferta}
                          props={data}
                          onClickCard={
                            !data.linkproduto
                              ? () => {
                                  history.push(`/descricao/2/${data.idoferta}`);
                                  viewDescricao(data);
                                }
                              : () => {
                                  window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                                  viewDescricao(data);
                                }
                          }
                        />
                      )}
                      {data.idtiporecomendacao === "3" && (
                        <CardCashbackVertical
                          key={data.idoferta}
                          props={data}
                          onClickCard={
                            !data.linkproduto
                              ? () => {
                                  history.push(`/descricao/3/${data.idoferta}`);
                                  viewDescricao(data);
                                }
                              : () => {
                                  window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                                  viewDescricao(data);
                                }
                          }
                        />
                      )}
                    </Box>
                  ))}
                  {destaques.length >= 5 && (
                    <CardVerMais
                      onClickVerMais={() =>
                        history.push(`/vermais/destaques/4`)
                      }
                    />
                  )}
                </BoxList>
              </Box>
            )}
            {descontoExclusivo.length > 0 && (
              <Box id="desconto-boxlist">
                <BoxList
                  isVisibleVermais={descontoExclusivo.length >= 5}
                  title={descontoExclusivoLabel}
                  bgcolorTitle={
                    card?.descontoexclusivo?.bgcortitle
                      ? card?.descontoexclusivo?.bgcortitle
                      : "transparent"
                  }
                  textcolorTitle={
                    card?.descontoexclusivo?.cortextotitle
                      ? card?.descontoexclusivo?.cortextotitle
                      : "#000"
                  }
                  onClick={() => history.push(`/vermais/descontoexclusivo/1`)}
                >
                  {descontoExclusivo.slice(0, 5).map((data, index) => (
                    <CardDescontoExclusivoVertical
                      key={data.idoferta}
                      props={data}
                      onClickCard={
                        !data.linkproduto
                          ? () => {
                              history.push(`/descricao/1/${data.idoferta}`);
                              viewDescricao(data);
                            }
                          : () => {
                              window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                              viewDescricao(data);
                            }
                      }
                    />
                  ))}
                  {descontoExclusivo.length >= 5 && (
                    <CardVerMais
                      onClickVerMais={() =>
                        history.push(`/vermais/descontoexclusivo/1`)
                      }
                    />
                  )}
                </BoxList>
              </Box>
            )}
            {ofertas.length > 0 && (
              <Box w="100%" id="ofertas-boxlist">
                <BoxList
                  isVisibleVermais={ofertas.length >= 5}
                  title={ofertasLabel}
                  bgcolorTitle={
                    card?.tabloide?.bgcortitle
                      ? card?.tabloide?.bgcortitle
                      : "transparent"
                  }
                  textcolorTitle={
                    card?.tabloide?.cortextotitle
                      ? card?.tabloide?.cortextotitle
                      : "#000"
                  }
                  onClick={() => history.push(`/vermais/tabloide/2`)}
                >
                  {ofertas.slice(0, 5).map((data, index) => (
                    <CardOfertaVertical
                      key={data.idoferta}
                      props={data}
                      onClickCard={
                        !data.linkproduto
                          ? () => {
                              history.push(`/descricao/2/${data.idoferta}`);
                              viewDescricao(data);
                            }
                          : () => {
                              window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                              viewDescricao(data);
                            }
                      }
                    />
                  ))}
                  {ofertas.length >= 5 && (
                    <CardVerMais
                      onClickVerMais={() => history.push(`/vermais/tabloide/2`)}
                    />
                  )}
                </BoxList>
              </Box>
            )}

            {dinheiroDeVolta.length > 0 && (
              <Box id="cashback-boxlist">
                <BoxList
                  isVisibleVermais={dinheiroDeVolta.length >= 5}
                  title={cashbackLabel}
                  bgcolorTitle={
                    card?.cashback?.bgcortitle
                      ? card?.cashback?.bgcortitle
                      : "transparent"
                  }
                  textcolorTitle={
                    card?.cashback?.cortextotitle
                      ? card?.cashback?.cortextotitle
                      : "#000"
                  }
                  onClick={() => history.push(`/vermais/cashback/3`)}
                >
                  {dinheiroDeVolta.slice(0, 5).map((data, index) => (
                    <CardCashbackVertical
                      key={data.idoferta}
                      props={data}
                      onClickCard={
                        !data.linkproduto
                          ? () => {
                              history.push(`/descricao/3/${data.idoferta}`);
                              viewDescricao(data);
                            }
                          : () => {
                              window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                              viewDescricao(data);
                            }
                      }
                    />
                  ))}
                  {dinheiroDeVolta.length >= 5 && (
                    <CardVerMais
                      onClickVerMais={() => history.push(`/vermais/cashback/3`)}
                    />
                  )}
                </BoxList>
              </Box>
            )}

            {destaques.length === 0 &&
              ofertas.length === 0 &&
              descontoExclusivo.length === 0 &&
              dinheiroDeVolta.length === 0 && <EmptyState />}
          </PullToRefresh>
        </Box>
      </Box>
    </Box>
  );
}
